.customCssCodeEditor {
  max-height: calc(100vh - 260px);
  min-height: 132px; // min-height to show three lines of code
}
